/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  EnumTest,
  EnumTestOptional,
  EnumTestMetaI,
  EnumTestTrackedI,
} from "./enum-test";
import { EnumTestTracked, EnumTestMeta } from "./enum-test";

/**
 *
 * @export
 * @interface APFutureClass
 */
export interface APFutureClassOptional {
  /**
   *
   * @type {EnumTest}
   * @memberof APFutureClass
   */
  enumTest?: EnumTest;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  sessionCount?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof APFutureClass
   */
  sessionDates?: Date[];
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  sessionLengthMinutes?: number;
  /**
   *
   * @type {boolean}
   * @memberof APFutureClass
   */
  signupsAvailable?: boolean;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  nextSignupsOpen?: Date;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  nextSignupsCount?: number;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  instructor?: string;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  location?: string;
}

export interface APFutureClass extends APFutureClassOptional {
  /**
   *
   * @type {EnumTest}
   * @memberof APFutureClass
   */
  enumTest?: EnumTest;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  sessionCount?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof APFutureClass
   */
  sessionDates?: Date[];
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  sessionLengthMinutes?: number;
  /**
   *
   * @type {boolean}
   * @memberof APFutureClass
   */
  signupsAvailable?: boolean;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  nextSignupsOpen?: Date;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  nextSignupsCount?: number;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  instructor?: string;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  location?: string;
}

export interface APFutureClassTrackedI {
  /**
   *
   * @type {EnumTest}
   * @memberof APFutureClass
   */
  enumTest?: EnumTest;
  enumTestIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  sessionCount?: number;
  sessionCountIsSet: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof APFutureClass
   */
  sessionDates?: Date[];
  sessionDatesIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  sessionLengthMinutes?: number;
  sessionLengthMinutesIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof APFutureClass
   */
  signupsAvailable?: boolean;
  signupsAvailableIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  nextSignupsOpen?: Date;
  nextSignupsOpenIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof APFutureClass
   */
  nextSignupsCount?: number;
  nextSignupsCountIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  instructor?: string;
  instructorIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof APFutureClass
   */
  location?: string;
  locationIsSet: boolean;
}

transformDatesMap.set("APFutureClass", function (model: APFutureClass) {
  if (Array.isArray(model.sessionDates))
    model.sessionDates = model.sessionDates.map((a) => new Date(a));
  if (typeof model.nextSignupsOpen == "string")
    model.nextSignupsOpen = new Date(model.nextSignupsOpen);
});

export type APFutureClassMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  enumTest: PropertyMeta<EnumTestMetaI>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sessionCount: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sessionDates: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sessionLengthMinutes: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupsAvailable: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  nextSignupsOpen: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  nextSignupsCount: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  instructor: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  location: PropertyMeta<MetaTypeBase<string>>;
}>;

export var APFutureClassMeta: APFutureClassMetaI = {} as APFutureClassMetaI;
APFutureClassMeta = typeMeta("APFutureClass", {
  enumTest: propertyMeta("enumTest", false, false, false, EnumTestMeta),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  sessionCount: propertyMeta(
    "sessionCount",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  sessionDates: propertyMeta(
    "sessionDates",
    true,
    false,
    false,
    MetaTypesBase.string,
  ),
  sessionLengthMinutes: propertyMeta(
    "sessionLengthMinutes",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupsAvailable: propertyMeta(
    "signupsAvailable",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  nextSignupsOpen: propertyMeta(
    "nextSignupsOpen",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  nextSignupsCount: propertyMeta(
    "nextSignupsCount",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  instructor: propertyMeta(
    "instructor",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  location: propertyMeta("location", false, false, false, MetaTypesBase.string),
});

const metaI = APFutureClassMeta;

registerMeta(() => {});

export class APFutureClassTracked implements APFutureClassTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  enumTest__I?: EnumTest = undefined;
  enumTestIsSet: boolean = false;
  set enumTest(v: undefined | EnumTest) {
    if (v !== undefined) {
      this.enumTest__I = v;
      this.enumTestIsSet = true;
    } else {
      this.enumTest__I = v || undefined;
      this.enumTestIsSet = false;
    }
    this.changeTracker = true;
  }
  get enumTest() {
    return this.enumTest__I;
  }
  instanceId__I?: number = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  sessionCount__I?: number = undefined;
  sessionCountIsSet: boolean = false;
  set sessionCount(v: undefined | number) {
    if (v !== undefined) {
      this.sessionCount__I = v;
      this.sessionCountIsSet = true;
    } else {
      this.sessionCount__I = v || undefined;
      this.sessionCountIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionCount() {
    return this.sessionCount__I;
  }
  sessionDates__I?: Date[] = undefined;
  sessionDatesIsSet: boolean = false;
  set sessionDates(v: undefined | Date[]) {
    if (v !== undefined) {
      this.sessionDates__I = v;
      this.sessionDatesIsSet = true;
    } else {
      this.sessionDates__I = v || undefined;
      this.sessionDatesIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionDates() {
    return this.sessionDates__I;
  }
  sessionLengthMinutes__I?: number = undefined;
  sessionLengthMinutesIsSet: boolean = false;
  set sessionLengthMinutes(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLengthMinutes__I = v;
      this.sessionLengthMinutesIsSet = true;
    } else {
      this.sessionLengthMinutes__I = v || undefined;
      this.sessionLengthMinutesIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLengthMinutes() {
    return this.sessionLengthMinutes__I;
  }
  signupsAvailable__I?: boolean = undefined;
  signupsAvailableIsSet: boolean = false;
  set signupsAvailable(v: undefined | boolean) {
    if (v !== undefined) {
      this.signupsAvailable__I = v;
      this.signupsAvailableIsSet = true;
    } else {
      this.signupsAvailable__I = v || undefined;
      this.signupsAvailableIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupsAvailable() {
    return this.signupsAvailable__I;
  }
  nextSignupsOpen__I?: Date = undefined;
  nextSignupsOpenIsSet: boolean = false;
  set nextSignupsOpen(v: undefined | Date) {
    if (v !== undefined) {
      this.nextSignupsOpen__I = v;
      this.nextSignupsOpenIsSet = true;
    } else {
      this.nextSignupsOpen__I = v || undefined;
      this.nextSignupsOpenIsSet = false;
    }
    this.changeTracker = true;
  }
  get nextSignupsOpen() {
    return this.nextSignupsOpen__I;
  }
  nextSignupsCount__I?: number = undefined;
  nextSignupsCountIsSet: boolean = false;
  set nextSignupsCount(v: undefined | number) {
    if (v !== undefined) {
      this.nextSignupsCount__I = v;
      this.nextSignupsCountIsSet = true;
    } else {
      this.nextSignupsCount__I = v || undefined;
      this.nextSignupsCountIsSet = false;
    }
    this.changeTracker = true;
  }
  get nextSignupsCount() {
    return this.nextSignupsCount__I;
  }
  instructor__I?: string = undefined;
  instructorIsSet: boolean = false;
  set instructor(v: undefined | string) {
    if (v !== undefined) {
      this.instructor__I = v;
      this.instructorIsSet = true;
    } else {
      this.instructor__I = v || undefined;
      this.instructorIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructor() {
    return this.instructor__I;
  }
  location__I?: string = undefined;
  locationIsSet: boolean = false;
  set location(v: undefined | string) {
    if (v !== undefined) {
      this.location__I = v;
      this.locationIsSet = true;
    } else {
      this.location__I = v || undefined;
      this.locationIsSet = false;
    }
    this.changeTracker = true;
  }
  get location() {
    return this.location__I;
  }
  constructor(config?: APFutureClassOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: APFutureClassOptional,
    options?: AssignOptions,
  ): APFutureClassTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.enumTest && this.enumTestApplyFilter(optionsRequired.filter)) {
      this.enumTest = config.enumTest;
      if (optionsRequired.unassign) this.enumTestIsSet = false;
      else this.enumTestIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.sessionCount &&
      this.sessionCountApplyFilter(optionsRequired.filter)
    ) {
      this.sessionCount = config.sessionCount;
      if (optionsRequired.unassign) this.sessionCountIsSet = false;
      else this.sessionCountIsSet = true;
    }
    if (
      config.sessionDates &&
      this.sessionDatesApplyFilter(optionsRequired.filter)
    ) {
      this.sessionDates = config.sessionDates;
      if (optionsRequired.unassign) this.sessionDatesIsSet = false;
      else this.sessionDatesIsSet = true;
    }
    if (
      config.sessionLengthMinutes &&
      this.sessionLengthMinutesApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLengthMinutes = config.sessionLengthMinutes;
      if (optionsRequired.unassign) this.sessionLengthMinutesIsSet = false;
      else this.sessionLengthMinutesIsSet = true;
    }
    if (
      config.signupsAvailable &&
      this.signupsAvailableApplyFilter(optionsRequired.filter)
    ) {
      this.signupsAvailable = config.signupsAvailable;
      if (optionsRequired.unassign) this.signupsAvailableIsSet = false;
      else this.signupsAvailableIsSet = true;
    }
    if (
      config.nextSignupsOpen &&
      this.nextSignupsOpenApplyFilter(optionsRequired.filter)
    ) {
      this.nextSignupsOpen = config.nextSignupsOpen;
      if (optionsRequired.unassign) this.nextSignupsOpenIsSet = false;
      else this.nextSignupsOpenIsSet = true;
    }
    if (
      config.nextSignupsCount &&
      this.nextSignupsCountApplyFilter(optionsRequired.filter)
    ) {
      this.nextSignupsCount = config.nextSignupsCount;
      if (optionsRequired.unassign) this.nextSignupsCountIsSet = false;
      else this.nextSignupsCountIsSet = true;
    }
    if (
      config.instructor &&
      this.instructorApplyFilter(optionsRequired.filter)
    ) {
      this.instructor = config.instructor;
      if (optionsRequired.unassign) this.instructorIsSet = false;
      else this.instructorIsSet = true;
    }
    if (config.location && this.locationApplyFilter(optionsRequired.filter)) {
      this.location = config.location;
      if (optionsRequired.unassign) this.locationIsSet = false;
      else this.locationIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): APFutureClassTrackedI {
    const cloned = {} as APFutureClassTrackedI;
    if (
      this.enumTestIsSetDeep() &&
      this.enumTestApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.enumTestIsSet = true;
      cloned.enumTest = this.enumTest;
    } else {
      //cloned.enumTestIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.sessionCountIsSetDeep() &&
      this.sessionCountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionCountIsSet = true;
      cloned.sessionCount = this.sessionCount;
    } else {
      //cloned.sessionCountIsSet = false
    }
    if (
      this.sessionDatesIsSetDeep() &&
      this.sessionDatesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionDatesIsSet = true;
      cloned.sessionDates = this.sessionDates;
    } else {
      //cloned.sessionDatesIsSet = false
    }
    if (
      this.sessionLengthMinutesIsSetDeep() &&
      this.sessionLengthMinutesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthMinutesIsSet = true;
      cloned.sessionLengthMinutes = this.sessionLengthMinutes;
    } else {
      //cloned.sessionLengthMinutesIsSet = false
    }
    if (
      this.signupsAvailableIsSetDeep() &&
      this.signupsAvailableApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupsAvailableIsSet = true;
      cloned.signupsAvailable = this.signupsAvailable;
    } else {
      //cloned.signupsAvailableIsSet = false
    }
    if (
      this.nextSignupsOpenIsSetDeep() &&
      this.nextSignupsOpenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nextSignupsOpenIsSet = true;
      cloned.nextSignupsOpen = this.nextSignupsOpen;
    } else {
      //cloned.nextSignupsOpenIsSet = false
    }
    if (
      this.nextSignupsCountIsSetDeep() &&
      this.nextSignupsCountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.nextSignupsCountIsSet = true;
      cloned.nextSignupsCount = this.nextSignupsCount;
    } else {
      //cloned.nextSignupsCountIsSet = false
    }
    if (
      this.instructorIsSetDeep() &&
      this.instructorApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorIsSet = true;
      cloned.instructor = this.instructor;
    } else {
      //cloned.instructorIsSet = false
    }
    if (
      this.locationIsSetDeep() &&
      this.locationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationIsSet = true;
      cloned.location = this.location;
    } else {
      //cloned.locationIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): APFutureClassTrackedI {
    if (!this.enumTestApplyFilter(filter)) this.enumTestIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.sessionCountApplyFilter(filter)) this.sessionCountIsSet = false;

    if (!this.sessionDatesApplyFilter(filter)) this.sessionDatesIsSet = false;

    if (!this.sessionLengthMinutesApplyFilter(filter))
      this.sessionLengthMinutesIsSet = false;

    if (!this.signupsAvailableApplyFilter(filter))
      this.signupsAvailableIsSet = false;

    if (!this.nextSignupsOpenApplyFilter(filter))
      this.nextSignupsOpenIsSet = false;

    if (!this.nextSignupsCountApplyFilter(filter))
      this.nextSignupsCountIsSet = false;

    if (!this.instructorApplyFilter(filter)) this.instructorIsSet = false;

    if (!this.locationApplyFilter(filter)) this.locationIsSet = false;

    return this;
  }
  enumTestApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.enumTest,
      APFutureClassMeta,
      this.enumTest,
      this,
    );
  }
  enumTestIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.enumTestIsSet && this.enumTestApplyFilter(filter)) return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.instanceId,
      APFutureClassMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.typeName,
      APFutureClassMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  sessionCountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.sessionCount,
      APFutureClassMeta,
      this.sessionCount,
      this,
    );
  }
  sessionCountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionCountIsSet && this.sessionCountApplyFilter(filter))
      return true;

    return false;
  }
  sessionDatesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.sessionDates,
      APFutureClassMeta,
      this.sessionDates,
      this,
    );
  }
  sessionDatesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionDatesIsSet && this.sessionDatesApplyFilter(filter))
      return true;

    return false;
  }
  sessionLengthMinutesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.sessionLengthMinutes,
      APFutureClassMeta,
      this.sessionLengthMinutes,
      this,
    );
  }
  sessionLengthMinutesIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.sessionLengthMinutesIsSet &&
      this.sessionLengthMinutesApplyFilter(filter)
    )
      return true;

    return false;
  }
  signupsAvailableApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.signupsAvailable,
      APFutureClassMeta,
      this.signupsAvailable,
      this,
    );
  }
  signupsAvailableIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupsAvailableIsSet && this.signupsAvailableApplyFilter(filter))
      return true;

    return false;
  }
  nextSignupsOpenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.nextSignupsOpen,
      APFutureClassMeta,
      this.nextSignupsOpen,
      this,
    );
  }
  nextSignupsOpenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nextSignupsOpenIsSet && this.nextSignupsOpenApplyFilter(filter))
      return true;

    return false;
  }
  nextSignupsCountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.nextSignupsCount,
      APFutureClassMeta,
      this.nextSignupsCount,
      this,
    );
  }
  nextSignupsCountIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.nextSignupsCountIsSet && this.nextSignupsCountApplyFilter(filter))
      return true;

    return false;
  }
  instructorApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.instructor,
      APFutureClassMeta,
      this.instructor,
      this,
    );
  }
  instructorIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instructorIsSet && this.instructorApplyFilter(filter)) return true;

    return false;
  }
  locationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      APFutureClassMeta.location,
      APFutureClassMeta,
      this.location,
      this,
    );
  }
  locationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationIsSet && this.locationApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.enumTestIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.sessionCountIsSetDeep(filter)) return true;
    if (this.sessionDatesIsSetDeep(filter)) return true;
    if (this.sessionLengthMinutesIsSetDeep(filter)) return true;
    if (this.signupsAvailableIsSetDeep(filter)) return true;
    if (this.nextSignupsOpenIsSetDeep(filter)) return true;
    if (this.nextSignupsCountIsSetDeep(filter)) return true;
    if (this.instructorIsSetDeep(filter)) return true;
    if (this.locationIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
